import { Option } from '@de/types/types';

export interface StepData {
  option?: Option | Option[];
  [key: string]: unknown;
}

/**
 * Utility function to validate if step data contains valid answers
 * @param stepData - The step data to validate
 * @param hasValidationErrors - Whether there are active validation errors for this step
 * @returns boolean indicating if the step has valid answers
 */
export function validateStepAnswers(
  stepData: StepData | null | undefined,
  hasValidationErrors = false,
): boolean {
  if (hasValidationErrors) return false;
  if (!stepData || !stepData.option) return false;

  const options = Array.isArray(stepData.option)
    ? stepData.option
    : [stepData.option];

  return options.some(
    (option: Option) =>
      option &&
      ((option.value !== undefined &&
        option.value !== null &&
        option.value !== '') ||
        (option.text !== undefined &&
          option.text !== null &&
          option.text !== '')),
  );
}
